export default "__VITE_ASSET__e244fef5__"